import { TableRow, TableCell, Stack, Box } from "@mui/material";
import { MassiveMessageUser } from "../../../redux/conversation/massive/massiveMessageUserSlice";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { ObjectTarget } from "../../../app/permissions";
import BadgedAvatar from "../../../features/base/BadgedAvatar";

interface MassiveMessageDetailRowProps {
    row: MassiveMessageUser;
    dismissedList?: any[];
}

const MassiveMessageDetailRow = ({ row, dismissedList }: MassiveMessageDetailRowProps) => {
    const dispatch = useAppDispatch();
    const cache = useSelector(selectObjectCache);

    const dismissed = dismissedList?.find((md: any) => (
        md.conversationMessageId === row.conversationMessageId && md.userId === row.userId
    ));
    const wasRead = !!dismissed;
    const color = (theme: any) => wasRead ? theme.palette.success : theme.palette;

    const student = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.STUDENT, `${row.studentId}`);
    const user = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.USER, `${row.userId}`);

    return (
        <TableRow key={row.id}>
            <TableCell align="left" sx={{ 
                backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <BadgedAvatar key={row.id}
                        title={`${student?.display ?? row.studentId}`} 
                        avatar={student?.image} 
                        size={"25px"}
                        fontSize="12px"
                    />
                    <Box>
                        {student?.display ?? row.studentId}
                    </Box>
                </Stack>
            </TableCell>
            <TableCell align="left" sx={{ 
                backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <BadgedAvatar key={row.id}
                        title={`${user?.display ?? row.userId}`} 
                        avatar={user?.image} 
                        size={"25px"}
                        fontSize="12px"
                    />
                    <Box>
                        {user?.display ?? row.userId}
                    </Box>
                </Stack>
            </TableCell>
            <TableCell align="left" sx={{ 
                backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>{wasRead ? "Sim" : "Não"}</TableCell>
        </TableRow>
    );
};

export default MassiveMessageDetailRow;
